import React from "react";
import { MdLocationOn } from "react-icons/md";

type Props = {
  lat: number;
  lng: number;
  data: any;
};

const SpottedParkings = (props: Props) => {
  return (
    <div className="bg-white p-3 rounded-lg shadow-md w-[100px] cursor-pointer absolute z-[1px] hover:bg-gray-200 hover:z-[2px]">
      <h5 className="font-bold text-black">{props.data.name}</h5>
      <MdLocationOn color={"black"} size={"30px"} className={"absolute mt-4"} />
    </div>
  );
};

export default SpottedParkings;
